<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <ul v-if="hasActions" class="chat-message__actions">
      <li
        v-for="(action, index) in chat.message_rich.actions"
        v-theme-bg-hover
        :class="checkActionState(index)"
        @click="clickAction(action)"
      >
        <a v-if="action.phone" :href="`tel:${action.phone}`" target="_parent">{{ action.phone }}</a>
        <template v-if="action.faq">{{ action.faq }}</template>
      </li>
    </ul>
  </chat-message>
</template>

<script>
import ActionWidget from './ActionWidget.vue'
import { EventBus } from 'ChatWidget/EventBus'
import { Chat } from 'src/apis'

export default {
  extends: ActionWidget,

  computed: {
    hasActions() {
      return (
        this.chat.message_rich &&
        this.chat.message_rich.actions &&
        this.chat.message_rich.actions.length
      )
    }
  },

  methods: {
    clickAction(action) {
      if (action.faq) {
        const options = {
          autoMessageFaqCode: action.code,
          autoMessageType: this.chat.message_rich.auto_message_info.type,
          messageID: this.chat.id
        }
        Chat.sendMessage(action.faq, options)
        this.$gtag.recordEventFaqAutoMessageAction(this.$i18n.locale, action)
      } else {
        this.$gtag.recordEventPhoneAutoMessageAction(this.$i18n.locale)
      }
    }
  }
}
</script>
